import environment from "./base";
import { Environment } from "../interfaces/Environment";

declare global {
  interface Window {
    API_URL: string;
  }
}

const baseApi = process.env.REACT_APP_API_URL;

const env = environment(baseApi || "");

const Config: Environment = {
  ...env,
  intervals: {
    ...env.intervals,
    logout: 300,
  },
  isProduction: true,
  isDevelopment: true,
};

export default Config;
